var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('localized-link',{staticClass:"nea-link",attrs:{"to":"/projects/0"}},[_vm._v(_vm._s(this.$t("general.projects")))]),_c('span',{staticClass:"separator"},[_vm._v("/")]),_c('localized-link',{staticClass:"nea-link",attrs:{"to":"/services/0"}},[_vm._v(_vm._s(this.$t("general.services")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }